import $ from "jquery";

$(() => {
  if (document.querySelector('.subscribe-modal')) {
    const modal = $(".subscribe-modal");
    const openButton = $(".signup-button");
    const closeButton = $(modal).children(".modal").children(".escape").children(".escape-button");
    
    openButton.on("click", function(){
      $(modal).removeClass("hidden"); 
      $(modal).addClass("flex");
    });

    closeButton.on("click", function(){
      $(modal).removeClass("flex"); 
      $(modal).addClass("hidden");
    });
  }
});